import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=6f631a8e&scoped=true&"
import script from "./LoadingDots.vue?vue&type=script&lang=ts&"
export * from "./LoadingDots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f631a8e",
  null
  
)

export default component.exports